import { FilterOptionInformation } from '@studyportals/search-filters';
import { ParameterType } from '@/study-search/enums';

import { IAsyncHandler, IFaq } from '@/study-search/interfaces';
import getters from '@/study-search/store/getters';
import { ParameterService } from '@/study-search/infrastructure/ParameterService';
import { Filter } from '../filter';

export abstract class FaqHandler implements IAsyncHandler<IFaq[]> {
	protected nextHandler: IAsyncHandler<IFaq[]>;
	protected parameterService: ParameterService = new ParameterService();

	public setNext(handler: IAsyncHandler<IFaq[]>): IAsyncHandler<IFaq[]> {
		this.nextHandler = handler;

		return this.nextHandler;
	}

	public async construct(): Promise<IFaq[]> {
		return this.canHandle() ? this.handle() : this.next();
	}

	protected get indexableFilters(): Filter[] {
		const filters = getters.getFilters();

		return filters.filter((_) => _.canBeIndexed());
	}

	protected async next(): Promise<IFaq[]> {
		return this.nextHandler.construct();
	}

	protected abstract canHandle(): boolean;

	protected abstract handle(): Promise<IFaq[]>;

	protected getFilterOption(type: ParameterType): FilterOptionInformation | undefined {
		const filters = getters.getFilters();

		const filter = filters.find((_) => _.type === type);
		if (!filter || !filter.definition) {
			return;
		}

		return filter.definition.getFilterOption(filter.values[0]);
	}
}
